import { render } from "./wfhProperties.vue?vue&type=template&id=dcc0ff44"
import script from "./wfhProperties.vue?vue&type=script&lang=js"
export * from "./wfhProperties.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__